module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Dropdown-Dropdown 1_left_Light Blue.dced80bf.svg";